import React, { useState } from "react";
import TitlePages from "../../../../layout/TitlePages";
import Breadcrumbs from "../../../../layout/Breadcrumbs";
import { avisospriv2024 } from "../../../../data/AvisosPriv/dataAvisosPriv";

const AvisosPriv2024 = () => {
  const [openItem, setOpenItem] = useState(null);
  const defaultImage = "https://itetlax.org.mx/assets/img/icons/2.png";

  const toggleAccordion = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  const docTypes = [
    { key: "simplificado", label: "📄 Simplificado" },
    { key: "integral", label: "📑 Integral" },
    { key: "corto", label: "📝 Corto" },
  ];

  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs
          path={[
            { label: "Transparencia", url: "/Transparencia" },
            { label: "Avisos de Privacidad", url: "/AvisosPrivacidad" },
            { label: "2024" },
          ]}
        />

        <TitlePages title="Transparencia" subTitle="Avisos de Privacidad 2024" />

        <div className="w-100 mt-3">
          {avisospriv2024.map((plan) => (
            <div key={plan.id} className="mb-2 border rounded">
              <div
                className="d-flex justify-content-between align-items-center p-2 bg-light"
                style={{ cursor: "pointer" }}
                onClick={() => toggleAccordion(plan.id)}
              >
                <div className="d-flex align-items-center">
                  <img
                    className="me-2"
                    src={defaultImage}
                    alt={plan.titulo}
                    width={30}
                  />
                  <span>{plan.titulo}</span>
                </div>
                <span>{openItem === plan.id ? "▲" : "▼"}</span>
              </div>

              {openItem === plan.id && (
                <div className="p-2 bg-white">
                  {docTypes.map(
                    (doc) =>
                      plan[doc.key] && (
                        <a
                          key={doc.key}
                          href={`https://itetlax.org.mx/assets/pdf/avisosPrivacidad/${plan[doc.key]}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-block mb-1 text-decoration-none"
                        >
                          {doc.label}
                        </a>
                      )
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AvisosPriv2024;